// dependencies
import { Map } from "immutable";
import { getMatchedRouteKeyValue } from "yarrr";

// selectors
import { getUI } from "Selectors/ui";

export const getReportID = (state) => getMatchedRouteKeyValue(state, "reportID", null);
export const getReport = (state) => getUI(state).get("bugReport", Map());
